import axios from 'axios';


const n = s => (s < 10 ? '0' : '') + s;
const cache = {};

const replaceTime = time => {
  const d = new Date(time);
  return [
    n(d.getFullYear()),
    n(d.getMonth() + 1),
    n(d.getDate())
  ].join('-');
};

// 消息
export const getNotices = () => {
  const url = '/ssc_golang/v1/user/notify/unread?random='+new Date().getTime();
  if (cache[url]) return cache[url];
  return axios.get(url).then(info => {

    if (info.result === 'ok') {
      info.data = info.data.map(item => {

        return {
          ...item,
          date: replaceTime(item.send_time * 1000)
        };
      });
      cache[url] = info;
    }

    return info;
  });
};

// 消息详情
export const getNoticeDetail = id => {
  const url = `/ssc_golang/v1/user/notify/info/${id}`+'?random='+new Date().getTime();
  if (cache[url]) return cache[url];
  return axios.get(url).then(info => {
    cache[url] = info;
    return info;
  });
};

// 注单操作通知（撤单/删除/恢复）
export const getOrderNotify = () => {
  const url = '/ssc_golang/v1/user/notify/order_notify?random=' + new Date().getTime();
  return axios.get(url);
};

// 标记注单通知已读
export const markOrderNotifyRead = (id) => {
  return axios.post('/ssc_golang/v1/user/notify/order_notify_read', { id });
};



// WEBPACK FOOTER //
// ./src/service/home.js